import React, { useState } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import Slider from 'react-slick'
import styled from 'styled-components'
import { Container, Row, Col } from 'reactstrap'

import { PocketMoneyDetermineTitle } from './pocket-money-determine'

const PocketMoneyBenefitWrapper = styled.div`
  padding-top: ${(props) => (props.onlyCarousel ? `0` : `70px`)};
  padding-bottom: 30px;
`

const PocketMoneyBenefitContainer = styled(Container)``

const PocketMoneyBenefitTitleWrapper = styled(Col)`
  @media (min-width: 768px) {
    padding-right: 50%;
  }
`

const PocketMoneyBenefitTitle = styled(PocketMoneyDetermineTitle)`
  margin-bottom: 80px;
`

const PocketMoneyBenefitSubTitle = styled.p`
  font-size: 22px;
  font-weight: 700;
  @media (max-width: 1399px) {
    font-size: 20px;
  }
`

const PocketMoneyBenefitRowWrapper = styled(Row)`
  justify-content: center;
  padding-bottom: 50px;
  @media (max-width: 575px) {
    padding-left: 10px;
    padding-right: 0;
  }
`

const PocketMoneyBenefitDescWrapper = styled(Col)`
  font-size: 18px;
  font-weight: 300;
  @media (max-width: 1399px) {
    font-size: 16px;
  }
`

const PocketMoneyBenefitSliderWrapper = styled(Col)`
  @media (max-width: 575px) {
    padding-left: 0;
    padding-right: 0;
  }
`

const PocketMoneyBenefitSlider = styled(Slider)`
  margin-top: 20px;
  .slick-list {
    @media (max-width: 575px) {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
  .slick-slide {
    @media (max-width: 575px) {
      padding-left: 10px;
      padding-right: 10px;
    }
    &.slick-center {
      &.slick-current {
        .name {
        }
      }
    }
  }
  .slick-dots {
    bottom: -40px;
    z-index: 10;
    li {
      width: 25px;
      margin-left: 0;
      margin-right: 0;
      &.slick-active {
        button {
          &:before {
            background-color: ${(props) => props.theme.colorGreenLight};
          }
        }
      }
      button {
        width: 25px;
        &:before {
          content: '';
          width: 15px;
          height: 15px;
          border: 1px solid ${(props) => props.theme.colorGreenLight};
          border-radius: 50%;
        }
      }
    }
  }
`

const PocketMoneyBenefitSliderItem = styled.div`
  position: relative;
  padding-left: 35px;
  padding-right: 35px;
  cursor: pointer;
  outline: none;
  @media (min-width: 768px) and (max-width: 991px) {
    padding-left: 15px;
    padding-right: 15px;
  }
  @media (max-width: 767px) {
    padding-left: 5px;
    padding-right: 5px;
  }
  @media (max-width: 575px) {
    padding-left: 0;
    padding-right: 0;
  }
`

const PocketMoneyBenefitSliderItemImageWrapper = styled.div``

const PocketMoneyBenefitSliderItemDescWrapper = styled.div`
  line-height: 1;
  p {
    font-size: 16px;
    font-weight: 300;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 30px;
    @media (min-width: 768px) and (max-width: 991px) {
      font-size: 18px;
    }
    @media (max-width: 767px) {
      /* font-size: 19px; */
    }
    @media (max-width: 575px) {
      font-size: 16px;
    }
  }
`

const PocketMoneyBenefit = ({ onlyCarousel = false }) => {
  const data = useStaticQuery(graphql`
    query {
      benefitImage1: file(relativePath: { eq: "parent/chapter/benefit1.png" }) {
        childImageSharp {
          fluid(maxWidth: 325) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      benefitImage2: file(relativePath: { eq: "parent/chapter/benefit2.png" }) {
        childImageSharp {
          fluid(maxWidth: 325) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      benefitImage3: file(relativePath: { eq: "parent/chapter/benefit3.png" }) {
        childImageSharp {
          fluid(maxWidth: 352) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `)

  const [activeSlide, setActiveSlide] = useState(0)

  const sliderSettings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    autoplaySpeed: 15000,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          centerMode: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          centerPadding: '70px',
        },
      },
    ],
  }

  const experts = [
    {
      name: (
        <>
          rodziców uważa, że edukacja finansowa dzieci jest ważna i{'\u00A0'}
          potrzebna
        </>
      ),
      namePlain: `rodziców uważa, że edukacja finansowa dzieci jest ważna i potrzebna`,
    },
    {
      name: (
        <>
          rodziców jest zdania, że najlepiej rozpocząć edukację finansową dzieci
          na{'\u00A0'}przełomie wieku przedszkolnego i{'\u00A0'}wczesnoszkolnego
        </>
      ),
      namePlain: `rodziców jest zdania, że najlepiej rozpocząć edukację finansową dzieci na przełomie wieku przedszkolnego i wczesnoszkolnego`,
    },
    {
      name: (
        <>
          rodziców przyznaje dzieciom kieszonkowe, by{'\u00A0'}uczyć je
          {'\u00A0'}samodzielnego dysponowania pieniędzmi
        </>
      ),
      namePlain: `rodziców przyznaje dzieciom kieszonkowe, by uczyć je samodzielnego dysponowania pieniędzmi`,
    },
  ]

  const changeActiveSlide = (number) => {
    setActiveSlide(number)
  }

  return (
    <PocketMoneyBenefitWrapper id="trivia" onlyCarousel={onlyCarousel}>
      <PocketMoneyBenefitContainer>
        {!onlyCarousel && (
          <Row>
            <PocketMoneyBenefitTitleWrapper xs={12}>
              <PocketMoneyBenefitTitle color="#91BD24">
                Czy dawanie kieszonkowego{' '}
                <span>
                  się <span>opłaca</span>?
                </span>
              </PocketMoneyBenefitTitle>
              <PocketMoneyBenefitSubTitle>
                Dysponowanie własnymi pieniędzmi to{'\u00A0'}znakomite narzędzie{' '}
                <span>edukacyjne</span>.
              </PocketMoneyBenefitSubTitle>
            </PocketMoneyBenefitTitleWrapper>
            <PocketMoneyBenefitDescWrapper xs={12} md={6}>
              <p>
                Dzięki kieszonkowemu Twoje dziecko zrozumie, że pieniądze nie
                spadają z{'\u00A0'}nieba, pozna ich wartość i{'\u00A0'}metody
                właściwego zarządzania nimi. Kieszonkowe nauczy je{'\u00A0'}
                również podejmowania własnych decyzji, nawet gdy będzie uczyło
                się na{'\u00A0'}błędach.
              </p>
            </PocketMoneyBenefitDescWrapper>
            <PocketMoneyBenefitDescWrapper xs={12} md={6}>
              <p>
                Dzięki temu wyrośnie na{'\u00A0'}odpowiedzialnego dorosłego,
                świadomego własnych finansów! Poznaj opinie naszych ekspertów:
              </p>
            </PocketMoneyBenefitDescWrapper>
          </Row>
        )}
        <PocketMoneyBenefitRowWrapper>
          <PocketMoneyBenefitSliderWrapper xs={12}>
            <PocketMoneyBenefitSlider {...sliderSettings}>
              {experts.map((expert, idx) => (
                <PocketMoneyBenefitSliderItem
                  key={idx}
                  onClick={() => changeActiveSlide(idx)}
                >
                  <PocketMoneyBenefitSliderItemImageWrapper
                    index={idx}
                    current={activeSlide}
                    className="image"
                  >
                    <Img
                      fluid={
                        data[`benefitImage${idx + 1}`].childImageSharp.fluid
                      }
                      className="expertImage"
                      alt={expert.namePlain}
                    />
                  </PocketMoneyBenefitSliderItemImageWrapper>

                  <PocketMoneyBenefitSliderItemDescWrapper
                    index={idx}
                    current={activeSlide}
                  >
                    <p>{expert.name}</p>
                  </PocketMoneyBenefitSliderItemDescWrapper>
                </PocketMoneyBenefitSliderItem>
              ))}
            </PocketMoneyBenefitSlider>
          </PocketMoneyBenefitSliderWrapper>
        </PocketMoneyBenefitRowWrapper>
      </PocketMoneyBenefitContainer>
    </PocketMoneyBenefitWrapper>
  )
}

export default PocketMoneyBenefit
